import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import vuetify from './plugins/vuetify'
import globalMixin from './mixins/globalMixin'

import FormatDateTime from './filters/FormatDateTime.js';

Vue.config.productionTip = false
Vue.filter('formatDateTime', FormatDateTime);

Vue.mixin(globalMixin)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
